(function (window) {
  const fontSizes = {
    's': (1.5 * 1) + 'em',
    'm': (1.5 * 1.5) + 'em',
    'l': (1.5 * 2) + 'em',
    'xl': (1.5 * 2.5) + 'em',
  };

  function createDisplayTimer(limitTimer, startTimestamp, settings) {
        if (!startTimestamp) {
            startTimestamp = new Date();
        }

        const containerEl = document.querySelector('.timer-container.' + settings.position);
        containerEl.textContent = '';

        function draw() {
            if ((settings.elapsed > settings.totalDuration || settings.stopped)) {
                if(settings.skip && !settings.stopped) {
                    activateSkip(settings);
                }
                settings.stopped = true;
                return;
            }

            const seconds = computeElapsedSeconds(startTimestamp, new Date(), limitTimer, settings);

            // do not display if hide is true
            if (settings.isHidden) {
                containerEl.textContent = '';
                return
            }

            const duration = durationFromSeconds(seconds);
            var time = duration.minutes > 0 ? pad2(duration.minutes) + ':' : '';
            time += pad2(duration.seconds);
            containerEl.textContent = time;
            decorateTimer(seconds, limitTimer, settings);
        }

        function computeElapsedSeconds(from, to, limitTimer, settings) {
            const elapsed = (to - from) / 1000;
            settings.elapsed = elapsed;
            return (settings.isStopWatch ? elapsed : limitTimer - elapsed);
        }

        function decorateTimer(seconds, limitTimer, settings) {
            containerEl.style.color = 'inherit';
            const hasPassedThreshold = (settings.isStopWatch ?  limitTimer - seconds : seconds - 1) < settings.dangerThreshold;
            if (hasPassedThreshold) {
                containerEl.style.color = settings.dangerColor;
            }

            const size = settings['size'];
            containerEl.style.fontSize = fontSizes[size];
        }

        return draw;
    }

    function durationFromSeconds(seconds) {
        const m = Math.trunc(seconds / 60);
        const s = Math.trunc(seconds % 60);
        return { minutes: m, seconds: s };
    }

    function pad2(number) {
        if (number < 0) return '00'; 
        return (number < 10 ? '0' : '') + number;
    }

    function activateSkip(settings) {
        if(columnForTrial('type', trialRow) === 'form') {
            const newTrial = settings.skipTo - 1;
            validateFormTrials(newTrial);
            return;
        }

        savePartialResponse('timeout');
        const oldTrial = window.trialRow;
        const oldTrialType = columnForTrial('responseType', oldTrial);
        window.trial = settings.skipTo - 1;
        window.trialRow = window.stimOrder[window.trial];
        if (oldTrialType !== 'mic') {
            window.endTrial();
        }
    }


    window.createDisplayTimer = createDisplayTimer;

})(window);